import {
    USER_SUBMIT_FRUI_QPFJ_BEGIN,
    USER_SUBMIT_FRUI_QPFJ_SUCCESS,
    USER_SUBMIT_FRUI_QPFJ_FAILURE,
    USER_SUBMIT_FRUI_QPFJ_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'

export function submitFrui_qpfj(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_SUBMIT_FRUI_QPFJ_BEGIN,
      });
  
    
    // if (params.id != undefined){
    //   apiurl = '/api/basic/acc';
    // }

    const promise = new Promise((resolve, reject) => {
        request({
          method:params.id != undefined ? 'PUT' : 'POST',
          url:"/api/basic/acc",
          data: params,
        }).then( data => {
            dispatch({
                type: USER_SUBMIT_FRUI_QPFJ_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: USER_SUBMIT_FRUI_QPFJ_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSubmitFrui_qpfjError() {
    return {
      type: USER_SUBMIT_FRUI_QPFJ_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_SUBMIT_FRUI_QPFJ_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          submitFrui_qpfjPending: true,
          submitFrui_qpfjError: null,
        };
  
      case USER_SUBMIT_FRUI_QPFJ_SUCCESS:
        // The request is success
        return {
          ...state,
          submitFrui_qpfjPending: false,
          submitFrui_qpfjError: null,
        };
  
      case USER_SUBMIT_FRUI_QPFJ_FAILURE:
        // The request is failed
        return {
          ...state,
          submitFrui_qpfjPending: false,
          submitFrui_qpfjError: action.data.error,
        };
  
      case USER_SUBMIT_FRUI_QPFJ_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          submitFrui_qpfjError: null,
        };
  
      default:
        return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/features/user/redux/submitFrui_qpfj.js